/* ===== SX About — comportamientos =====
   Web components: <sx-text>, <sx-poligrafo>, <sx-hold>
   + delegación global para [data-sx-censor] y [data-sx-copy]            */
(() => {
  if (window.__sxAbout) return;
  window.__sxAbout = true;

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ%#*?&!0123456789';
  const rnd = () => CHARS[(Math.random() * CHARS.length) | 0];
  const fmt = (s, o) => (s || '').replace(/\{(\w+)\}/g, (m, k) => (k in o ? o[k] : m));

  /* ---------- Tachado y copiar (delegado) ---------- */
  async function copy(btn) {
    const code = btn.dataset.sxCopy;
    try { await navigator.clipboard.writeText(code); }
    catch (_) {
      const t = document.createElement('textarea');
      t.value = code; t.style.cssText = 'position:fixed;opacity:0';
      document.body.append(t); t.select();
      try { document.execCommand('copy'); } catch (__) {}
      t.remove();
    }
    if (!btn._label) btn._label = btn.textContent;
    btn.textContent = btn.dataset.done || 'Copiado';
    clearTimeout(btn._t);
    btn._t = setTimeout(() => (btn.textContent = btn._label), 2000);
  }

  document.addEventListener('click', e => {
    const c = e.target.closest('[data-sx-censor]');
    if (c) { c.setAttribute('aria-pressed', c.classList.toggle('is-open')); return; }
    const b = e.target.closest('[data-sx-copy]');
    if (b) copy(b);
  });

  /* ---------- <sx-text>: descifrar (scramble) o escribir (type) ---------- */
  class SxText extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.mode = this.getAttribute('mode') || 'scramble';

      const vis = document.createElement('span');
      vis.setAttribute('aria-hidden', 'true');
      while (this.firstChild) vis.appendChild(this.firstChild);
      const sr = document.createElement('span');
      sr.className = 'sx-sr';
      sr.textContent = vis.textContent;
      this.append(sr, vis);

      this.nodes = [];
      const w = document.createTreeWalker(vis, NodeFilter.SHOW_TEXT);
      while (w.nextNode()) if (w.currentNode.nodeValue.trim()) this.nodes.push({ n: w.currentNode, t: w.currentNode.nodeValue });
      if (reduce) return;

      if (this.mode === 'type') {
        this.chars = [];
        for (const o of this.nodes) {
          const f = document.createDocumentFragment();
          for (const ch of o.t) {
            if (/\s/.test(ch)) f.append(ch);
            else { const s = document.createElement('span'); s.className = 'sx-c'; s.textContent = ch; f.append(s); this.chars.push(s); }
          }
          o.n.replaceWith(f);
        }
        this.total = this.chars.length;
      } else {
        this.total = this.nodes.reduce((a, o) => a + [...o.t].length, 0);
        this.draw(0);
      }

      if (this.getAttribute('trigger') !== 'manual') {
        this.io = new IntersectionObserver(es => {
          if (es.some(e => e.isIntersecting)) { this.io.disconnect(); this.play(); }
        }, { threshold: 0.35 });
        this.io.observe(this);
      }
    }
    disconnectedCallback() { this.io && this.io.disconnect(); cancelAnimationFrame(this.raf); }

    draw(p) {
      const r = Math.floor(p * this.total);
      let g = 0;
      for (const o of this.nodes) {
        let s = '';
        for (const ch of o.t) s += g++ < r || /\s/.test(ch) ? ch : rnd();
        o.n.nodeValue = s;
      }
    }

    play() {
      if (reduce || this.playing || !this.total) return;
      this.playing = true;
      const dur = +this.getAttribute('duration') || (this.mode === 'type' ? Math.min(2600, this.total * 28) : 900);
      const t0 = performance.now();
      let last = 0;
      const step = t => {
        const p = Math.min(1, (t - t0) / dur);
        if (this.mode === 'type') this.chars.forEach((c, i) => c.classList.toggle('on', i < p * this.total));
        else if (t - last > 45 || p === 1) { last = t; this.draw(p); }
        if (p < 1) this.raf = requestAnimationFrame(step); else this.playing = false;
      };
      this.raf = requestAnimationFrame(step);
    }
  }

  /* ---------- <sx-hold>: mantener pulsado ---------- */
  class SxHold extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const btn = this.querySelector('.sx-hold__btn');
      const fill = this.querySelector('.sx-hold__fill');
      const label = this.querySelector('.sx-hold__label');
      const hint = this.querySelector('.sx-hold__hint');
      const reveal = this.querySelector('.sx-hold__reveal');
      const dur = +this.dataset.duration || 2500;
      let t0 = 0, raf = 0, done = false;
      const set = p => (fill.style.transform = `scaleX(${p})`);

      const complete = () => {
        done = true;
        cancelAnimationFrame(raf);
        btn.classList.add('is-done');
        btn.setAttribute('aria-disabled', 'true');
        label.textContent = this.dataset.done || '';
        if (hint) hint.hidden = true;
        reveal.hidden = false;
        reveal.querySelectorAll('sx-text').forEach(el => el.play && el.play());
      };
      const loop = t => {
        const p = Math.min(1, (t - t0) / dur);
        set(p);
        if (p >= 1) complete(); else raf = requestAnimationFrame(loop);
      };
      const start = e => {
        if (done) return;
        if (e.type === 'keydown') { if (e.repeat || ![' ', 'Enter'].includes(e.key)) return; e.preventDefault(); }
        fill.style.transition = 'none';
        t0 = performance.now();
        raf = requestAnimationFrame(loop);
      };
      const stop = () => {
        if (done) return;
        cancelAnimationFrame(raf);
        fill.style.transition = 'transform .35s ease';
        set(0);
      };
      btn.addEventListener('pointerdown', start);
      ['pointerup', 'pointerleave', 'pointercancel', 'blur'].forEach(ev => btn.addEventListener(ev, stop));
      btn.addEventListener('keydown', start);
      btn.addEventListener('keyup', stop);
      btn.addEventListener('contextmenu', e => e.preventDefault());
    }
  }

  /* ---------- <sx-poligrafo>: juego verdad / mentira ---------- */
  class SxPoli extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const el = n => this.querySelector(`[data-el="${n}"]`);
      this.qs = [...this.querySelectorAll('.sx-poli__data > li')].map(li => ({
        q: li.querySelector('[data-q]').textContent.trim(),
        a: li.dataset.answer === 'true',
        why: (li.querySelector('[data-why]')?.textContent || '').trim()
      }));
      if (!this.qs.length) return;

      this.eQ = el('q'); this.eStatus = el('status'); this.eStamp = el('stamp'); this.eWhy = el('why');
      this.eSteps = el('steps'); this.eGame = el('game'); this.eRes = el('result'); this.eRt = el('rt');
      this.eWin = el('win'); this.eRetry = el('retry'); this.cv = el('cv');
      this.btns = [...this.querySelectorAll('[data-ans]')];
      this.total = this.qs.length;
      this.min = Math.min(+this.dataset.min || this.total, this.total);
      this.delay = +this.dataset.delay || 2800;
      this.eSteps.innerHTML = this.qs.map(() => '<span class="sx-poli__step"></span>').join('');
      this.stepEls = [...this.eSteps.children];

      this.addEventListener('click', e => {
        const b = e.target.closest('[data-ans]');
        if (b) this.answer(b.dataset.ans === 'true', b);
        else if (e.target.closest('[data-el="retry"]')) this.reset();
      });
      this.initWave();
      this.reset();
    }
    disconnectedCallback() { cancelAnimationFrame(this.wraf); clearTimeout(this.tm); clearTimeout(this.mt); this.io && this.io.disconnect(); }

    status(t) { this.eStatus.textContent = t; }

    reset() {
      this.score = 0;
      this.eRes.hidden = true;
      this.eGame.hidden = false;
      this.stepEls.forEach(s => s.classList.remove('is-done', 'is-now'));
      this.show(0);
    }

    show(i) {
      this.i = i; this.lock = false;
      this.eQ.textContent = this.qs[i].q;
      this.stepEls.forEach((s, k) => { s.classList.toggle('is-done', k < i); s.classList.toggle('is-now', k === i); });
      this.eStamp.classList.remove('is-in');
      this.eWhy.textContent = '';
      this.btns.forEach(b => { b.classList.remove('is-picked'); b.removeAttribute('aria-disabled'); });
      this.status(fmt(this.dataset.lblCount, { n: i + 1, t: this.total }));
      this.setMode('idle');
    }

    answer(v, btn) {
      if (this.lock) return;
      this.lock = true;
      const q = this.qs[this.i];
      const ok = v === q.a;
      if (ok) this.score++;
      btn && btn.classList.add('is-picked');
      this.btns.forEach(b => b.setAttribute('aria-disabled', 'true'));
      this.setMode(q.a ? 'truth' : 'lie');
      this.status(q.a ? this.dataset.lblStable : this.dataset.lblLie);
      this.eStamp.textContent = ok ? this.dataset.ok : this.dataset.ko;
      void this.eStamp.offsetWidth;
      this.eStamp.classList.add('is-in');
      this.eWhy.textContent = q.why;
      clearTimeout(this.tm);
      this.tm = setTimeout(() => (this.i + 1 >= this.total ? this.finish() : this.show(this.i + 1)), this.delay);
    }

    finish() {
      const win = this.score >= this.min;
      this.eGame.hidden = true;
      this.eRes.hidden = false;
      this.eRt.textContent = fmt(win ? this.dataset.win : this.dataset.fail, { score: this.score, total: this.total });
      if (this.eWin) this.eWin.hidden = !win;
      this.eRetry.hidden = win;
      this.stepEls.forEach(s => { s.classList.add('is-done'); s.classList.remove('is-now'); });
      this.status(this.dataset.lblStable);
      this.setMode('finale');
      this.eRes.focus({ preventScroll: true });
    }

    /* --- onda del polígrafo --- */
    setMode(m) {
      clearTimeout(this.mt);
      const lie = m === 'lie';
      this.color = getComputedStyle(this).getPropertyValue(lie ? '--sx-alert' : '--sx-wave').trim() || '#fff';
      this.classList.toggle('is-lie', lie);
      this.tgt = { idle: 0.025, truth: 0.2, lie: 0.85, finale: 0.7 }[m];
      if (lie) this.mt = setTimeout(() => (this.tgt = 0.4), 1100);
      if (m === 'truth' || m === 'finale') this.mt = setTimeout(() => (this.tgt = 0.03), m === 'finale' ? 1800 : 900);
      if (reduce) this.paint();
    }

    initWave() {
      const cv = this.cv;
      this.ctx = cv.getContext('2d');
      this.buf = []; this.amp = 0.025; this.tgt = 0.025; this.vis = true; this.color = '#fff';
      const fit = () => {
        const r = cv.getBoundingClientRect();
        this.d = Math.min(window.devicePixelRatio || 1, 2);
        cv.width = Math.max(1, r.width * this.d);
        cv.height = Math.max(1, r.height * this.d);
        const n = Math.ceil(r.width / 2) + 2;
        while (this.buf.length < n) this.buf.unshift(0);
        if (this.buf.length > n) this.buf.splice(0, this.buf.length - n);
        this.paint();
      };
      fit();
      new ResizeObserver(fit).observe(cv);
      if (reduce) return;
      this.io = new IntersectionObserver(es => (this.vis = es[0].isIntersecting));
      this.io.observe(cv);
      let n = 0;
      const tick = t => {
        this.wraf = requestAnimationFrame(tick);
        if (!this.vis || n++ % 2) return;
        this.amp += (this.tgt - this.amp) * 0.07;
        this.buf.push(((Math.random() * 2 - 1) * 0.8 + Math.sin(t / 37) * 0.35) * this.amp);
        this.buf.shift();
        this.paint();
      };
      this.wraf = requestAnimationFrame(tick);
    }

    paint() {
      const { ctx, cv, d } = this;
      if (!ctx) return;
      const h = cv.height, mid = h / 2;
      ctx.clearRect(0, 0, cv.width, h);
      ctx.lineWidth = 1.6 * d; ctx.lineJoin = 'round'; ctx.strokeStyle = this.color;
      ctx.beginPath();
      this.buf.forEach((v, i) => {
        const x = i * 2 * d, y = mid - v * h * 0.46;
        i ? ctx.lineTo(x, y) : ctx.moveTo(x, y);
      });
      ctx.stroke();
    }
  }

  customElements.get('sx-text') || customElements.define('sx-text', SxText);
  customElements.get('sx-hold') || customElements.define('sx-hold', SxHold);
  customElements.get('sx-poligrafo') || customElements.define('sx-poligrafo', SxPoli);
})();
